module.exports = __webpack_public_path__ + "img/viber.5463ec39.svg";